<template>
  <span>
    <span
      v-if="!cartIcon"
      class="row pt-1 m-0 pl-2 pr-2 pb-2"
      :class="fav?'':' pdp-cart-area'"
    >
      <div v-if="plp">
        <button
          type="button"
          :class=classListAddToCart
          v-if="isAddToCart"
          @click.stop="add(product)"
          :disabled="!(product.stock || product.stock < 0)"
          :id="'plp-add-to-cart'+product.product_id"
										data-test="cartActionPLPAddToCart"
        >
          Add to Cart
        </button>
        <button
          type="button"
          :class=classListBuyNow
          v-if="isBuyNow"
          :disabled="!(product.stock || product.stock < 0)"
          @click.stop="buyNow(product)"
          :id="'plp-buy-now'+product.product_id"
										data-test="cartActionPLPBuyNow"
        >
          Buy Now
        </button>
      </div>
      <div
        :class="fav?'':'col-6 px-1'"
        v-else-if="pdp"
      >
        <button
          type="button"
          :class="fav?'btn btn-sm blue-btn':classListAddToCart"
          v-if="isAddToCart && !outOfStock"
          :id="'pdp-add-to-cart-'+product.product_id+vendorId"
          :disabled="!(product.stock || product.stock < 0)"
          @click.stop="add(product)"
										data-test="cartActionPDPAddToCart"
        >
          {{show? 'Go to Cart' : 'Add to Cart'}}
        </button>
      </div>
      <div
        class="col-6 px-1"
        v-if="isBuyNow && !outOfStock"
      >
        <button
          type="button"
          class="btn buy-now-btn"
          v-if="isBuyNow"
          :disabled="!(product.stock || product.stock < 0)"
          @click.stop="buyNow(product)"
          :id="'pdp-buy-now-'+product.product_id"
										data-test="cartActionPDPBuyNow"
        >
          Buy Now
        </button>
      </div>

      <!--Exclude feature: Notify Me-->

      <!--<div class="col-12 px-1" v-if="outOfStock">-->
      <!--<button type="button"-->
      <!--class="btn buy-now-btn"-->
      <!--v-if="outOfStock"-->
      <!--:id="'pdp-buy-now-'+product.product_id"-->
      <!--@click.stop="notifyMeOutofStock(product)"-->
      <!--&gt;-->
      <!--Notify Me-->
      <!--</button>-->
      <!--</div>-->

      <!--Exclude feature: Notify Me-->
    </span>
    <span
      class="addtocart"
      v-if="cartIcon"
    >
      <button
        title="Add to cart"
        class="btn-wishlist"
        :disabled="!(product.stock || product.stock < 0)"
        @click.stop="add(product)"
        :id="'cart-icon-'+product.product_id"
								data-test="cartActionCartBtn"
      >
        <svg class="i-icon icon-cart"
													data-test="cartActionCartIcon">
          <use xlink:href="#icon-cart"></use>
        </svg>
      </button>
    </span>
  </span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { cartApis } from '@/services/ApiServices/cartApis'
import { customerApi } from '@/services/ApiServices/customerApi'
import * as productApi from '../../../services/ApiServices/productApi'

export default {
	name: 'CartAction',
	props: {
		plp: {
			type: Boolean,
			default: false
		},
		pdp: {
			type: Boolean,
			default: false
		},
		fav: {
			type: Boolean,
			default: false
		},
		product: Object,
		vendorId: {
			type: String,
			default: ''
		},
		isBuyNow: {
			type: Boolean,
			default: false
		},
		listing: {
			type: Boolean,
			default: false
		},
		isAddToCart: {
			type: Boolean,
			default: false
		},
		outOfStock: {
			type: Boolean,
			default: false
		},
		classListAddToCart: {
			type: String,
			default: 'btn add-to-cart ripplelink '
		},
		classListBuyNow: {
			type: String,
			default: 'btn buy-now-btn'
		},
		cartIcon: {
			default: false,
			type: Boolean
		}
	},
	data () {
		return {
			quantity: 1
		}
	},
	computed: {
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('cart', ['getCartProducts', 'getOrderCart']),
		show () {
			const products = this.getCartProducts
				.filter(pro =>
					pro.product_id === this.product.product_id && pro.vendor_id === this.vendorId)
			return products.length > 0
		}
	},
	methods: {
		...mapActions('cart', ['addToCart', 'buyNowProduct', 'emptyCart']),
		...mapActions('buynow', ['addToBuyNow']),
		async add (product) {
			if (this.show === true) {
				this.$router.push({
					path: '/cart',
					query: {
						display_text: 'My Cart'
					}
				})
			} else {
				const products = this.getCartProducts
					.filter(pro =>
						(pro.product_id === this.product.product_id &&
              pro.vendor_id === this.vendorId))
				if (products.length > 0) {
					this.quantity = products[0].quantity
					// if (product && this.quantity + 1 <= product.stock &&
					//   product.stock < product.max_quantity) {
					//   this.cartAnimation();
					// } else if (product.stock > product.max_quantity &&
					//   (this.quantity + 1 <= product.max_quantity)) {
					//   this.cartAnimation();
					// }
				}
				// this.emptyCart();
				if (product.vendor_id !== this.vendorId &&
          product.vendor_product_inventories &&
          product.vendor_product_inventories.length > 0) {
					const vendorIndex = product.vendor_product_inventories.findIndex(vendor => vendor.vendor_id === this.vendorId)
					await productApi.assignVendorInventoryAndPromotionalPrices(product, vendorIndex)
				}
				const productPayloadToCart = JSON.parse(JSON.stringify(product))
				productPayloadToCart.quantity = 1
				this.addToCart(productPayloadToCart)
				if (this.isAuthenticated) {
					if (this.getCartProducts.length > 0) {
						cartApis.insertCart()
					}
				}
				this.$router.push({
					path: '/cart',
					query: {
						display_text: 'My Cart'
					}
				})
			}
		},
		buyNow (product) {
			if (this.isAuthenticated) {
				const productPayloadToCart = JSON.parse(JSON.stringify(product))
				productPayloadToCart.quantity = 1
				this.addToBuyNow(productPayloadToCart)
				// this.buyNowProduct(product);
				this.$router.push('/checkout')
			} else {
				const productPayloadToCart = JSON.parse(JSON.stringify(product))
				productPayloadToCart.quantity = 1
				this.addToBuyNow(productPayloadToCart)
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'checkOut'
					}
				})
			}
		},
		notifyMeOutofStock (product) {
			const data = {
				product_id: product.product_id,
				vendor_id: product.vendor_id
			}
			if (this.isAuthenticated) {
				customerApi.notifyMe(data)
			} else {
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'previous'
					}
				})
			}
		}
	}
}
</script>
